export default "/template/resource//static/media/img_qiye@2x.55ac8a9e.png";